import { useCreateOrUpdateMultipleprintInAuction } from "@/api/related-fields";
import { LinkableType } from "@/components/LinksManagement";
import { FieldConfig } from "@/config/forms/general";
import { MultipleprintInAuction } from "@/lib/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import LinksDrawerLayout from "./LinksDrawerLayout";

const MultipleprintInAuctionDrawer = ({
  fields,
  data,
  queryId,
  type,
}: {
  fields: FieldConfig[] | undefined;
  data: MultipleprintInAuction;
  queryId: string;
  type: LinkableType;
}) => {
  const schema = z.object({
    ventesDansEstampesMultiplesDescriptionNumeroLot: z.string().optional(),
    ventesDansEstampesMultiplesDescriptionReproduitPage: z.string().optional(),
    ventesDansEstampesMultiplesDescriptionEstimationHaute: z
      .string()
      .optional(),
    ventesDansEstampesMultiplesDescriptionEstimationBasse: z
      .string()
      .optional(),
    ventesDansEstampesMultiplesDescriptionVendu: z.boolean().optional(),
    ventesDansEstampesMultiplesDescriptionResultatNonListe: z
      .boolean()
      .optional(),
    ventesDansEstampesMultiplesDescriptionNonVendu: z.boolean().optional(),
    ventesDansEstampesMultiplesDescriptionNonVenu: z.boolean().optional(),
    ventesDansEstampesMultiplesDescriptionRetire: z.boolean().optional(),
    ventesDansEstampesMultiplesDescriptionMiseAPrix: z.string().optional(),
    ventesDansEstampesMultiplesDescriptionPrixMarteau: z.string().optional(),
    ventesDansEstampesMultiplesDescriptionPrixAvecFrais: z.string().optional(),
    ventesDansEstampesMultiplesDescriptionExemplaireVendu: z
      .string()
      .optional(),
    auction: z.object({
      ventesDescriptionNumeroVente: z.string().optional(),
      ventesDescriptionResume: z.string().optional(),
    }),
  });

  const { mutate: createOrUpdateMultipleprintInAuction } =
    useCreateOrUpdateMultipleprintInAuction(queryId, type);

  const form = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
    defaultValues: {
      auction: data.auction,
      ventesDansEstampesMultiplesDescriptionNumeroLot:
        data.ventesDansEstampesMultiplesDescriptionNumeroLot,
      ventesDansEstampesMultiplesDescriptionReproduitPage:
        data.ventesDansEstampesMultiplesDescriptionReproduitPage,
      ventesDansEstampesMultiplesDescriptionEstimationHaute:
        data.ventesDansEstampesMultiplesDescriptionEstimationHaute,
      ventesDansEstampesMultiplesDescriptionEstimationBasse:
        data.ventesDansEstampesMultiplesDescriptionEstimationBasse,
      ventesDansEstampesMultiplesDescriptionVendu:
        data.ventesDansEstampesMultiplesDescriptionVendu,
      ventesDansEstampesMultiplesDescriptionResultatNonListe:
        data.ventesDansEstampesMultiplesDescriptionResultatNonListe,
      ventesDansEstampesMultiplesDescriptionNonVendu:
        data.ventesDansEstampesMultiplesDescriptionNonVendu,
      ventesDansEstampesMultiplesDescriptionNonVenu:
        data.ventesDansEstampesMultiplesDescriptionNonVenu,
      ventesDansEstampesMultiplesDescriptionRetire:
        data.ventesDansEstampesMultiplesDescriptionRetire,
      ventesDansEstampesMultiplesDescriptionMiseAPrix:
        data.ventesDansEstampesMultiplesDescriptionMiseAPrix,
      ventesDansEstampesMultiplesDescriptionPrixMarteau:
        data.ventesDansEstampesMultiplesDescriptionPrixMarteau,
      ventesDansEstampesMultiplesDescriptionPrixAvecFrais:
        data.ventesDansEstampesMultiplesDescriptionPrixAvecFrais,
      ventesDansEstampesMultiplesDescriptionExemplaireVendu:
        data.ventesDansEstampesMultiplesDescriptionExemplaireVendu,
    },
  });

  const onSubmit = (formData: z.infer<typeof schema>) => {
    createOrUpdateMultipleprintInAuction({
      id: data.id,
      multipleprintId: data.multipleprint.id,
      auctionId: data.auction.id,
      ...formData,
    });
  };

  return (
    <LinksDrawerLayout
      form={form}
      fields={fields ?? []}
      recordId={data.id}
      onSubmit={onSubmit}
    />
  );
};

export default MultipleprintInAuctionDrawer;
